import { useState } from "react";
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  Spinner
} from "reactstrap";

const DeleteAvailabilityConfirmationModal = ({
  open,
  onClose,
  onDelete,
  item
}) => {
  const [loading, setLoading] = useState(false);

  const handleConfirm = async () => {
    setLoading(true);
    await onDelete();
    setLoading(false);
    onClose();
  };

  return (
    <Modal isOpen={open} toggle={onClose} className="miui-dialog">
      <ModalHeader toggle={onClose}>Delete Availability</ModalHeader>

      <ModalBody>
        <p className="mb-0">
          Are you sure you want to delete the availability for{" "}
          <strong>
            {item?.role || "this role"}
          </strong>
          ? This action cannot be undone.
        </p>
      </ModalBody>

      <ModalFooter>
        <Button
          outline
          color="secondary"
          className="miui-button"
          onClick={onClose}
          disabled={loading}
        >
          Cancel
        </Button>

        <Button
          color="danger"
          className="miui-button"
          onClick={handleConfirm}
          disabled={loading}
        >
          {loading && <Spinner size="sm" className="me-1" />}
          Delete
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export { DeleteAvailabilityConfirmationModal };
